import request from '@/utils/request'
import qs from "qs";
//获取游客或者登录用户的咨询列表
export function customerServiceList(params) {
    return request({
        url: '/customerService/list',
        method: 'get',
        params: params
    })
}
export function commonQuestion(params){
    return request({
        url: '/customerService/commonQuestion',
        method: 'get',
        params: params
    })
}


// WEBPACK FOOTER //
// ./src/api/online.js